import { normalizeGpsHeading } from './gps-marker-animator';

export interface GpsTruckMarkerStyle {
  headingDegrees?: number | string | null;
  selected?: boolean;
  stale?: boolean;
}

/**
 * Creates the shared supplied top-view truck marker without requiring a
 * Google Maps map ID or the Advanced Marker library. Heading zero faces north.
 */
export function gpsTruckMarkerIcon(style: GpsTruckMarkerStyle = {}): google.maps.Icon {
  const selected = !!style.selected;
  const stale = !!style.stale;
  const size = selected ? 56 : 46;
  const heading = normalizeGpsHeading(style.headingDegrees) ?? 0;
  const halo = selected ? `<circle cx="32" cy="32" r="29" fill="#66EDFF" opacity=".28"/>` : '';
  const opacity = stale ? '.56' : '1';
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64">\n`
    + `${halo}\n`
    + `<g transform="rotate(${heading} 32 32)" opacity="${opacity}">\n`
    + `<rect x="15" y="5" width="34" height="54" rx="5" fill="rgba(0,0,0,0.15)" transform="translate(0, 1.5)"/>\n`
    + `<rect x="12" y="14" width="4" height="8" rx="1.5" fill="#111"/><rect x="48" y="14" width="4" height="8" rx="1.5" fill="#111"/>\n`
    + `<rect x="12" y="42" width="4" height="8" rx="1.5" fill="#111"/><rect x="48" y="42" width="4" height="8" rx="1.5" fill="#111"/>\n`
    + `<rect x="12" y="51" width="4" height="8" rx="1.5" fill="#111"/><rect x="48" y="51" width="4" height="8" rx="1.5" fill="#111"/>\n`
    + `<rect x="16" y="4" width="32" height="56" rx="4" fill="#1A1A1A"/>\n`
    + `<rect x="16" y="18" width="32" height="40" rx="2" fill="#FFFFFF"/>\n`
    + `<line x1="22" y1="24" x2="22" y2="52" stroke="#E0E0E0" stroke-width="1.5" stroke-linecap="round"/><line x1="26" y1="24" x2="26" y2="52" stroke="#E0E0E0" stroke-width="1.5" stroke-linecap="round"/><line x1="32" y1="24" x2="32" y2="52" stroke="#E0E0E0" stroke-width="1.5" stroke-linecap="round"/><line x1="38" y1="24" x2="38" y2="52" stroke="#E0E0E0" stroke-width="1.5" stroke-linecap="round"/><line x1="42" y1="24" x2="42" y2="52" stroke="#E0E0E0" stroke-width="1.5" stroke-linecap="round"/>\n`
    + `<path d="M 18 18 L 18 10 C 18 6, 46 6, 46 10 L 46 18 Z" fill="#3A3D40"/><path d="M 21 8 L 43 8 L 41 12 L 23 12 Z" fill="#52B2F2"/><path d="M 19 10 L 20 10 L 21 16 L 19 16 Z" fill="#334E68"/><path d="M 45 10 L 44 10 L 43 16 L 45 16 Z" fill="#334E68"/>\n`
    + `<rect x="24" y="5" width="16" height="2" rx="0.5" fill="#1A1A1A"/><rect x="11" y="9" width="4" height="2" rx="0.5" fill="#3A3D40"/><rect x="49" y="9" width="4" height="2" rx="0.5" fill="#3A3D40"/>\n`
    + `<rect x="18" y="58" width="5" height="1.5" fill="#FF3B30"/><rect x="41" y="58" width="5" height="1.5" fill="#FF3B30"/>\n`
    + `</g></svg>`;
  const icon: google.maps.Icon = {
    url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`
  };

  if (typeof google !== 'undefined' && google.maps?.Size && google.maps?.Point) {
    icon.scaledSize = new google.maps.Size(size, size);
    icon.anchor = new google.maps.Point(size / 2, size / 2);
  }
  return icon;
}
